import { FC, ReactNode } from 'react';
import {
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableProps,
} from '@mui/material';
import { TranslatableString } from 'i18n/translations/no';
import { useTranslation } from 'react-i18next';
import { ChevronRight as ArrowIcon } from '@mui/icons-material';
import { TableRowProps } from '../Mobile/Row/MobileTableRow';
import './DesktopTable.scss';

type TableColumn = {
  label: TranslatableString | '';
  key: string;
  align?: 'left' | 'right' | 'center';
  className?: string;
  render?: (value: string | number, row: TableRowProps) => ReactNode;
};

export type DesktopTableProps = {
  columns: TableColumn[];
  data: TableRowProps[];
  tableProps?: Partial<Omit<TableProps, 'children'>>;
  onRowClick?: (row: TableRowProps) => void;
};

const DesktopTable: FC<DesktopTableProps> = ({
  columns,
  data,
  tableProps,
  onRowClick,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper} className="remora-table-container">
      <MUITable stickyHeader {...tableProps}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.key}
                align={col.align}
                className={col.className}
              >
                {t(col.label)}
              </TableCell>
            ))}
            {onRowClick && (
              <TableCell
                key="actions"
                align="center"
                className="arrow-column"
              ></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow
              key={idx}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  align={col.align}
                  className={col.className}
                >
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </TableCell>
              ))}

              {onRowClick && (
                <TableCell key="actions" align="center">
                  <div className="arrow-column">
                    <ArrowIcon className="arrow-icon" />
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </MUITable>
    </TableContainer>
  );
};

export default DesktopTable;
